export const singularise = (text: string) => {
	if (/ies$/.test(text)) {
		return text.substring(0, text.length - 3) + 'y';
	}

	if (/ses$/.test(text)) {
		return text.substring(0, text.length - 2);
	}

	if (/s$/.test(text)) {
		return text.substring(0, text.length - 1);
	}

	return text;
};

export const singulariseArticle = (text: string) => {
	const signularised = singularise(text).toLowerCase();
	if (/^[aeio]/i.test(signularised)) {
		// Note - leaving out the U - as whether A or An depends on pronunciation.
		// e.g. A unit, not an unit.
		return `An ${signularised}`;
	}

	return `A ${signularised}`;
};
